/*  ========================================================================
    # Scripts - Newsletter subscription
    ========================================================================  */

/**
 * Script that handles the newsletter subscription.
 */

const NewsletterSubscription = {
  cfg: {
    formElements: document.querySelectorAll('.c-newsletter-form'),
    state: {
      error: 'c-newsletter-form--error',
      success: 'c-newsletter-form--success',
      pending: 'c-newsletter-form--pending',
    }
  },

  /**
   * Fill hidden fields.
   */
  fillHiddenFields(form) {
    // Get all URL Parameters
    const urlParams = new URLSearchParams(window.location.search);
    const formId = form.getAttribute('id');


    // Fill hidden fields
    form.querySelector('#utm_source_newsletter_' + formId).value = urlParams.get('utm_source');
    form.querySelector('#utm_medium_newsletter_' + formId).value = urlParams.get('utm_medium');
    form.querySelector('#utm_campaign_newsletter_' + formId).value = urlParams.get('utm_campaign');
    form.querySelector('#utm_term_newsletter_' + formId).value = urlParams.get('utm_term');
    form.querySelector('#utm_content_newsletter_' + formId).value = urlParams.get('utm_content');
    form.querySelector('#conversion_url_newsletter_' + formId).value = window.location.href;
    form.querySelector('#gclid_newsletter_' + formId).value = urlParams.get('gclid');
  },

  /**
   * Handle form submission.
   */

  async formSubmit(captchaToken, form) {
    const formData = new FormData(form);
    const formAction = form.getAttribute('data-action');
    formData.append('recaptchaToken', captchaToken);
    formData.append('formAction', formAction);
    form.classList.add(this.cfg.state.pending);

    try {
      const response = await fetch('/wp-json/vandy/v1/form/send/newsletterSubscription', {
        method: 'POST',
        body: formData
      });

      if (response.ok && response.status === 200) {
        console.log('Form submitted successfully');
        form.classList.add(this.cfg.state.success);
        form.classList.remove(this.cfg.state.pending);
        form.classList.remove(this.cfg.state.error);
      } else {
        form.classList.remove(this.cfg.state.pending);
        form.classList.remove(this.cfg.state.success);
        form.classList.add(this.cfg.state.error);

        console.error('Form submission failed:', response.statusText);
      }
    } catch (error) {
      form.classList.remove(this.cfg.state.pending);
      form.classList.remove(this.cfg.state.success);
      form.classList.add(this.cfg.state.error);
      console.error(error);
    }
  },

  /**
   * Initialize.
   */
  init() {

    // Handle form submit
    if (this.cfg.formElements && this.cfg.formElements.length > 0) {

      this.cfg.formElements.forEach(form => {
        // Fill hidden fields
        this.fillHiddenFields(form);
        form.addEventListener('submit', e => {
          e.preventDefault();
          grecaptcha.ready(() => {
            grecaptcha
              .execute(window.jsLocalize.recaptchaSiteKey, { action: 'submit' })
              .then(token => {
                this.formSubmit(token, form);
              });
          });
        });
      });
    }
  }
};

export default NewsletterSubscription;
